import React from 'react'
import Header from './comp/Header'
import Footer from './comp/Footer';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import './style.scss';
import Products from './comp/Products';
function App() {
  return (
    <div>
      <Header/>
      <Footer/>
    </div>
  )
}

export default App
